import { Dialog, DialogTitle, makeStyles } from "@material-ui/core";
import MaterialTable from "material-table";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import {
  CommonUrl, logoutMsg, myHeaderStyle,
  mySearchFieldStyle, NONCE,
  TIME_STAMP
} from "../../../common-url/CommonUrl";
import SettingForm from "../component/SettingForm";

const useStyles = makeStyles(theme => ({
  root: {
    /*"& .MuiPaper-root": {
      borderBottom: "none",
      backgroundColor:"transparent",
      boxShadow:"none"
    },*/
    "& .MuiInput-underline:before": {
      borderBottom: 0
    },
    "& .MuiInput-underline:after": {
      borderBottom: 0
    },
    "& .MuiInput-root": {
      borderBottom: 0
    },
    "&:last-child td": {
      // borderBottom: 0,
    }
  }
}));

export default function DefaultSettingList() {
  const [setting, setSetting] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const [settingForm, setSettingForm] = useState(false);
  const classes = useStyles();
  const history = useHistory();

  const columns = [
    {
      title: "Sr No",
      render: rowData => rowData.tableData.id + 1,
      width: "10%"
    },
    { title: "Setting Key", field: "vSettingKey", editable: false },
    { title: "Name", field: "vName", editable: false },
    {
      title: "Updated At",
      field: "iUpdatedAt",
      editable: false,
      filtering: false,
      render: rowData => (
        <span>
          {moment(rowData.iUpdatedAt * 1000).format("MMMM Do YYYY, h:mm:ss a")}
        </span>
      )
    }
  ];
  // -------------------------------------------------------------------
  // -------------get the all setting list at initial loading---------------
  // -------------------------------------------------------------------
  const myTextIcon = React.useRef(null);

  useEffect(() => {
    fetchSettings();
    myTextIcon.current.parentNode.parentNode.classList.remove(
      "MuiIconButton-root"
    );
  }, []);
  const encToken = useSelector(({ auth }) => auth.authToken, shallowEqual);

  const fetchSettings = async () => {
    await fetch(CommonUrl.defaultSettingsBaseUrl + "/view", {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        token: encToken,
        nonce: NONCE,
        timestamp: TIME_STAMP
      }
    })
      .then(response => response.json())
      .then(response => {
        if (response.code == 401) {
          history.push("/logout");
          toast.info(logoutMsg, { autoClose: 5000 });
        } else {
          setSetting(response.data);
        }
      });
  };
  // -------------------------------------------------------------------
  // -----------------------update a setting--------------------------------
  // -------------------------------------------------------------------
  const handleRowUpdate = selectedRowData => {
    setSelectedRow(selectedRowData);
    setSettingForm(true);
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSettingForm(false);
  };
  // -------------------------------------------------------------------
  // -------------------------------------------------------------------
  return (
    <div className="App">
      <Dialog
        open={settingForm}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className="text-center pb-0" id="alert-dialog-title">
          {selectedRow.vSettingKey}
        </DialogTitle>
        <SettingForm data={selectedRow}></SettingForm>
      </Dialog>
      {/* material table starts */}
      <div className={classes.root}>
        <MaterialTable
          title="Default Settings List"
          style={{ paddingInline: "30px", paddingTop: "10px" }}
          data={setting}
          columns={columns}
          actions={[
            {
              icon: () => <div ref={myTextIcon}></div>,
              isFreeAction: true
            },
            {
              icon: "edit",
              tooltip: "Edit settings",
              iconProps: { color: "secondary" },
              // iconProps: { style: { fontSize: "small", color: "red" } },
              onClick: (event, selectedRowData) => {
                handleRowUpdate(selectedRowData);
              }
            }
          ]}
          onRowClick={(evt, selectedRowData) => {
            handleRowUpdate(selectedRowData);
          }}
          options={{
            // filtering: true,
            actionsColumnIndex: -1,
            addRowPosition: "first",
            headerStyle: myHeaderStyle,
            searchFieldStyle: mySearchFieldStyle,
            pageSize: 10, // make initial page size
            emptyRowsWhenPaging: false, // To avoid of having empty rows
            pageSizeOptions: [10, 20, 50]
          }}
        />
      </div>
      {/* material table ends */}
    </div>
  );
}
